import { gql } from "@/__generated__/gql";

export const CURRENT_USER_GROUP_ORGS = gql(`
  query CurrentUserOrgs($first: Int, $after: String) {
    me {
      id
      officialOrganizations(first: $first, after: $after) {
        edges {
          node {
            id
            uuid
            name
            logo {
              id
              url(size: 24)
            }
            seatsAvailable
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
        totalCount
      }
    }
  }
`);
